<template>
    <div class="middle-box text-center loginscreen" v-cloak>
        <div>
            <div>
                <div :style="logo_style">
                    <img class="logo" :src="logo_url" style="width:100%;" :alt="partner_name" />
                </div>
                <div :style="easescreen_logo_style">
                    <img v-if="show_easescreen_logo" class="logo m-t-md" src="/img/logo-easescreen.svg" style="width:100%;" alt="EWI" />
                </div>
            </div>
            <br>
            <p class="">{{ form_text }}</p>

            <div v-if="mode==='register-success'">
                <span class=" " >
                    <h3 v-html="t_register_success"></h3>
                </span>
            </div>
            <div v-if="mode==='login-success'">
                <span class=" " >
                    <h3 v-html="t_login_success"></h3>
                </span>
            </div>
            <form v-else id="form-register" class="m-t">
                <slot></slot>
                <template v-if="mode==='register'">
                    <div :class="['form-group', errors.hasOwnProperty('firstname') ? ' has-error' : '']">
                        <input type="text" name="firstname" class="form-control " :placeholder="t_first_name" required v-model="firstname">
                        <span v-if="errors.hasOwnProperty('firstname')" class="help-block ">
                            <strong>{{ errors['firstname'] }}</strong>
                        </span>
                    </div>
                    <div :class="['form-group', errors.hasOwnProperty('lastname') ? ' has-error' : '']">
                        <input type="text" name="lastname" class="form-control " :placeholder="t_last_name" required v-model="lastname">
                        <span v-if="errors.hasOwnProperty('lastname')" class="help-block ">
                            <strong>{{ errors['lastname'] }}</strong>
                        </span>
                    </div>
                    <div :class="['form-group', errors.hasOwnProperty('email') || errors.hasOwnProperty('active') ? ' has-error' : '']">
                        <input type="email" name="email" class="form-control " :placeholder="t_email" required autofocus v-model="email">
                        <span v-if="errors.hasOwnProperty('email')" class="help-block ">
                            <strong>{{ errors['email'] }}</strong>
                        </span>
                        <span v-if="errors.hasOwnProperty('active')" class="help-block ">
                            <strong>{{ errors['active'] }}</strong>
                        </span>
                    </div>
                    <div :class="['form-group', errors.hasOwnProperty('email_confirmation') ? ' has-error' : '']">
                        <input type="email" name="email_confirmation" class="form-control " :placeholder="t_email_confirmation" required v-model="email_confirmation">
                        <span v-if="errors.hasOwnProperty('email_confirmation')" class="help-block ">
                            <strong>{{ errors['email_confirmation'] }}</strong>
                        </span>
                    </div>
                </template>
                <template v-if="mode==='login'">
                    <div :class="['form-group', errors.hasOwnProperty('email') || errors.hasOwnProperty('active') ? ' has-error' : '']">
                        <input type="email" name="email" class="form-control " :placeholder="t_email" required autofocus v-model="email">
                        <span v-if="errors.hasOwnProperty('email')" class="help-block ">
                            <strong>{{ errors['email'] }}</strong>
                        </span>
                        <span v-if="errors.hasOwnProperty('active')" class="help-block ">
                            <strong>{{ errors['active'] }}</strong>
                        </span>
                    </div>
                    <div :class="['form-group', errors.hasOwnProperty('password') ? ' has-error' : '']">
                        <input type="password" name="password" class="form-control" :placeholder="t_password" required v-model="password">
                        <span v-if="errors.hasOwnProperty('password')" class="help-block ">
                            <strong>{{ errors['password'] }}</strong>
                        </span>
                    </div>
                </template>
                <template v-if="mode==='register' || mode==='login'">
                    <div :class="['form-group', errors.hasOwnProperty('pairing_code') ? ' has-error' : '']">
                        <input type="text" name="pairing_code" class="form-control " :placeholder="t_pairing_code" required autofocus v-model="pairing_code" minlength="8" maxlength="8" :title="t_pairing_code_hint">
                        <span v-if="errors.hasOwnProperty('pairing_code')" class="help-block ">
                            <strong>{{ errors['pairing_code'] }}</strong>
                        </span>
                    </div>
                </template>
                <template v-if="mode==='register' && license_server_active">
                    <div class="form-group" v-if="test_duration!=='0'">
                        <select v-model="link" name="link" class="form-control  input-sm" style="font-size: 12px;">
                            <option value="0" style="font-size: 12px;">{{ t_no_link }}</option>
                            <option value="1" style="font-size: 12px;">{{ t_link_pk }}</option>
                        </select>
                    </div>
                    <template v-if="link==='1' || test_duration==='0'">
                        <div :class="['form-group', errors.hasOwnProperty('productkey') ? ' has-error' : '']">
                            <input type="text" name="productkey" class="form-control" :placeholder="t_productkey + ': XXXXX-XXXXX-XXXXX-XXXXXX-XXXXXX'" required v-model="productkey">
                            <span v-if="errors.hasOwnProperty('productkey')" class="help-block">
                                    <strong>{{ errors['productkey'] }}</strong>
                                </span>
                        </div>
                    </template>
                </template>
                <template v-if="mode==='project-select'">
                    <div class="form-group">
                        <select v-model="project" name="link" class="form-control  input-sm" style="font-size: 12px;">
                            <option v-for="(name, id) in project_list" :value="id" style="font-size: 12px;">{{ name }}</option>
                        </select>
                    </div>
                </template>
                <template v-if="mode==='register' || mode==='login' || mode==='project-select'">
                    <div id="register-submit" class="btn btn-primary full-width m-b" @click="register()" :class="loading || preError ? 'disabled' : ''" :style="loading ? 'cursor:wait' : 'cursor:pointer'">
                        {{ mode === 'register' ? t_register : t_register_device }}
                    </div>
                    <div v-if="errors.hasOwnProperty('general')" :class="['form-group', errors.hasOwnProperty('general') ? ' has-error' : '']">
                            <span class="help-block ">
                                <strong>{{ errors['general'] }}</strong>
                            </span>
                    </div>
                    <div class="inline" v-if="mode==='register'">
                        <a @click="mode='login'" class="pwlost "><small>{{ t_or_login }}</small></a>
                    </div>
                    <div class="inline" v-else>
                        <a @click="mode='register'" class="pwlost"><small>{{ t_or_register }}</small></a>
                    </div>
                </template>
            </form>
            <p class="m-t "> <small v-html='t_copyright'></small> </p>
        </div>
    </div>
</template>

<script>
import Template from "../content/elements/template";
export default {
    name: "register-partner",
    components: {Template},
    props: [
        'version',
        'url',
        'license_server_active',
        'partner_uri',
        'partner_name',
        'logo_url',
        'logo_style',
        'easescreen_logo_style',
        'test_duration',
        'given_pairing_code',
        'spam_task',
        'show_easescreen_logo',
        'form_text',
    ],
    data: function () {
        return {
            errors: {},
            link: '0',
            firstname: '',
            lastname: '',
            email: '',
            email_confirmation: '',
            pairing_code: '',
            productkey: '',
            password: '',
            mode: 'register',
            project: null,
            project_list: [],
            project_name: '',
            inited: false,
            loading:false,
            preError:false,

            t_register_success: Lang.langGet("The registration was successful.</br>Check your inbox, you should have received an email. There, you can set your password."),
            t_first_name: Lang.langGet('First name'),
            t_last_name: Lang.langGet('Last name'),
            t_email: Lang.langGet('Email address'),
            t_email_confirmation: Lang.langGet('Confirm email address'),
            t_email_confirmation_error: Lang.langGet('Email addresses must be the same.'),
            t_pairing_code: Lang.langGet('Pairing-ID'),
            t_pairing_code_hint: Lang.langGet('See device above QR-code.'),
            t_screen_name: Lang.langGet('New screen name'),
            t_login: Lang.langGet("Login"),
            t_or_login: Lang.langGet("Register device with existing user"),
            t_or_register: Lang.langGet("Register new user"),
            t_register: Lang.langGet("Register"),
            t_register_device: Lang.langGet("Register device"),
            t_copyright: Lang.langGet("easescreen Webinterface :version &copy; 2016 - :year", {"version": this.version, "year": new Date().getFullYear()}),
            t_no_link: Lang.langGet("Sign up for test duration of :days days", {days: this.test_duration}),
            t_link_pk: Lang.langGet("Register product key"),
            t_productkey: Lang.langGet("Product Key"),
            t_password: Lang.langGet("Password"),
        }
    },
    watch: {
        link: function (val, oldVal) {
            if (oldVal !== val) {
                this.inited = true;
            }
        },
        project: function (val) {
            this.project_name = this.project_list[val];
            if (this.errors.hasOwnProperty('project')) {
                delete this.errors['project'];
            }
        },
        email: function () {
            this.check_pre_errors();
            if (this.errors.hasOwnProperty('email')) {
                delete this.errors['email'];
            }
        },
        email_confirmation: function () {
            this.check_pre_errors();
        },
        mode: function () {
            this.check_pre_errors()
        },
        pairing_code: function () {
            if (this.errors.hasOwnProperty('pairing_code')) {
                delete this.errors['pairing_code'];
            }
        },
        screen_name: function () {
            if (this.errors.hasOwnProperty('screen_name')) {
                delete this.errors['screen_name'];
            }
        },
        firstname: function () {
            if (this.errors.hasOwnProperty('firstname')) {
                delete this.errors['firstname'];
            }
        },
        lastname: function () {
            if (this.errors.hasOwnProperty('lastname')) {
                delete this.errors['lastname'];
            }
        },
    },
    computed: {
        t_login_success: function () {
            return Lang.langGet("The device was registered successfully and added to your Project :project.</br>You can close this window.", {project: this.project_name});
        }
    },
    mounted: function () {
        this.pairing_code = this.given_pairing_code ?? '';
    },
    methods: {
        check_pre_errors: function () {
            if (this.mode === 'register') {
                if (this.email_confirmation !== this.email) {
                    this.errors['email_confirmation'] = this.t_email_confirmation_error;

                    if (this.mode === 'register') {
                        this.preError = true;
                    }
                } else if (this.errors.hasOwnProperty('email_confirmation')) {
                    delete this.errors['email_confirmation'];

                    if (this.mode === 'register') {
                        this.preError = false;
                    }
                }
            } else {
                this.preError = false;
            }
        },
        register: function () {
            if (this.loading || this.preError) {
                return;
            }

            this.loading = true;
            axios.post('/partner/' + this.partner_uri, {
                mode: this.mode,
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                email_confirmation: this.email_confirmation,
                pairing_code: this.pairing_code,
                link: this.link,
                productkey: this.productkey,
                password: this.password,
                project: this.project,
                partner_uri: this.partner_uri
            }).then((data) => {
                this.loading = false;
                this.errors = [];

                if (data.status === 200) {
                    this.mode = data.data.mode;
                    if (this.mode === 'project-select') {
                        this.project_list = data.data.project_list;
                        this.project = Object.keys(this.project_list)[0];
                    } else {
                        this.project_name = data.data.project_name;
                    }
                }
            }).catch((error) => {
                this.loading = false;
                if (error.response.status === 400 || error.response.status === 422) {
                    let errors = {};
                    Object.keys(error.response.data.errors).forEach((key) => {
                        if (Array.isArray(error.response.data.errors[key])) {
                            errors[key] = error.response.data.errors[key].join('    ');
                        } else {
                            errors[key] = error.response.data.errors[key];
                        }
                    });
                    this.errors = errors;
                }
            })
        }
    }
}
</script>
